import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon
} from 'react-share';
import './socialshare.styles.scss';
import { SOCIAL_SHARE_URL, SOCIAL_SHARE_TEXT } from './../../utils/strings';

const SocialShare = () => {
  const url = SOCIAL_SHARE_URL;
  const shareText = SOCIAL_SHARE_TEXT;
  return (
    <div className="socialShare">
      <FacebookShareButton
        url={url}
        quote={shareText}
        className="share-button"
      >
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      <WhatsappShareButton
        url={url}
        title={shareText}
        separator=":: "
        className="share-button"
      >
        <WhatsappIcon size={32} round />
      </WhatsappShareButton>
      <LinkedinShareButton url={url} className="share-button">
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>
      <TwitterShareButton
        url={url}
        title={shareText}
        className="share-button"
      >
        <TwitterIcon size={32} round />
      </TwitterShareButton>
    </div>);
};
export default SocialShare;